export enum CheckoutRoutes {
  DirectDebit = '/direct-debit',
}
